import React from "react";
import * as Dati from "src/Dati";
import { _BondsRatesDetails, _ProductsTab } from "..";
import { IFideTassiProduct } from "./BondsRatesForm";
import { getGroupedProducts } from "../common/CompanyProducts/helpers";

interface IBondsRatesTabProps {
    DurationTypes: Dati.TDictTipo;
    Products: IFideTassiProduct[];
    OnAddProduct: (product: IFideTassiProduct) => void;
    OnChange: (e: string, val?: unknown) => void;
}

export const _BondsRatesTab: React.FC<IBondsRatesTabProps> = ({ Products, DurationTypes, OnAddProduct, OnChange }) => {
    const groupedProducts: IFideTassiProduct[][] = getGroupedProducts(Products);

    return (
        <_ProductsTab
            GroupedProducts={groupedProducts}
            RenderTabContent={index => <_BondsRatesDetails Data={groupedProducts[index]} DurationTypes={DurationTypes} OnAddProduct={OnAddProduct} OnChange={OnChange} />}
        />
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsRates/BondsRatesTab.tsx